import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { useTheme } from 'styled-components';

import { FormattedTariffValues } from '../../../../ui';
import { StyledKeylineDiv, StyledTable } from '../../../../ui/Styled';
import getRecommendedTariffValues from '../../../../utils/getRecommendedTariffValues';
import toTitleCase from '../../../../utils/toTitleCase';

const TariffItem = ({ tariff, showSupplier = false, hasTariffBeenRecentlyUpdated = false }) => {
  const theme = useTheme();
  const history = useHistory();
  const { exportValue, importValue } = getRecommendedTariffValues(tariff);

  return (
    <>
      <div className="d-none d-sm-block">
        <StyledKeylineDiv>
          <StyledTable>
            <thead>
              <tr>
                <StyledTable.Th></StyledTable.Th>
                {showSupplier && <StyledTable.Th className="text-left">Supplier</StyledTable.Th>}
                <StyledTable.Th className="text-left">Tariff</StyledTable.Th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <StyledTable.Td className="py-4">
                  <strong>Import</strong>
                </StyledTable.Td>
                {showSupplier && (
                  <StyledTable.Td className="text-nowrap">
                    {toTitleCase(tariff.tariff_combination.import_tariff_supplier_name)}
                  </StyledTable.Td>
                )}
                <StyledTable.Td>{tariff.tariff_combination.import_tariff_name}</StyledTable.Td>
              </tr>
              <tr>
                <StyledTable.Td className="py-4">
                  <strong>Export</strong>
                </StyledTable.Td>
                {showSupplier && (
                  <StyledTable.Td>{toTitleCase(tariff.tariff_combination.export_tariff_supplier_name)}</StyledTable.Td>
                )}
                <StyledTable.Td>{tariff.tariff_combination.export_tariff_name}</StyledTable.Td>
              </tr>
            </tbody>
          </StyledTable>
        </StyledKeylineDiv>
      </div>
      {!hasTariffBeenRecentlyUpdated && <div className="mb-4" />}

      {/* MOBILE */}
      <div className="d-block d-sm-none">
        <StyledKeylineDiv className="mb-4">
          <StyledTable>
            <thead>
              <tr>
                <StyledTable.Th></StyledTable.Th>
                <StyledTable.Th className="text-left">Import tariff</StyledTable.Th>
              </tr>
            </thead>
            <tbody>
              {showSupplier && (
                <tr>
                  <StyledTable.Td className="py-4">
                    <strong>Supplier</strong>
                  </StyledTable.Td>
                  <StyledTable.Td>{toTitleCase(tariff.tariff_combination.import_tariff_supplier_name)}</StyledTable.Td>
                </tr>
              )}
              <tr>
                <StyledTable.Td className="py-4">
                  <strong>Tariff</strong>
                </StyledTable.Td>
                <StyledTable.Td>{tariff.tariff_combination.import_tariff_name}</StyledTable.Td>
              </tr>
              <tr>
                <StyledTable.Td className="py-4 text-nowrap">
                  <strong>Tariff Type</strong>
                </StyledTable.Td>
                <StyledTable.Td>{tariff.tariff_combination.import_tariff_type}</StyledTable.Td>
              </tr>
              {/*<tr>
                <StyledTable.Td className="py-4 text-nowrap">
                  <strong>Standing Charges</strong>
                </StyledTable.Td>
                <StyledTable.Td>
                  standing charges here...
                  p/day
                </StyledTable.Td>
              </tr>
              {/*<tr>
                <StyledTable.Td className="py-4 text-nowrap">
                  <strong>Comments</strong>
                </StyledTable.Td>
                <StyledTable.Td>{tariff.tariff_combination.import_tariff_comments}</StyledTable.Td>
              </tr>*/}
            </tbody>
          </StyledTable>
        </StyledKeylineDiv>
        <StyledKeylineDiv>
          <StyledTable>
            <thead>
              <tr>
                <StyledTable.Th></StyledTable.Th>
                <StyledTable.Th className="text-left">Export tariff</StyledTable.Th>
              </tr>
            </thead>
            <tbody>
              {showSupplier && (
                <tr>
                  <StyledTable.Td className="py-4">
                    <strong>Supplier</strong>
                  </StyledTable.Td>
                  <StyledTable.Td>{toTitleCase(tariff.tariff_combination.export_tariff_supplier_name)}</StyledTable.Td>
                </tr>
              )}
              <tr>
                <StyledTable.Td className="py-4">
                  <strong>Tariff</strong>
                </StyledTable.Td>
                <StyledTable.Td>{tariff.tariff_combination.export_tariff_name}</StyledTable.Td>
              </tr>
              <tr>
                <StyledTable.Td className="py-4 text-nowrap">
                  <strong>Tariff Type</strong>
                </StyledTable.Td>
                <StyledTable.Td>{tariff.tariff_combination.export_tariff_type}</StyledTable.Td>
              </tr>
              {/*<tr>
                <StyledTable.Td className="py-4 text-nowrap">
                  <strong>Standing Charges</strong>
                </StyledTable.Td>
                <StyledTable.Td>
                  standing charges here...
                  p/day
                </StyledTable.Td>
              </tr>
             <tr>
                <StyledTable.Td className="py-4 text-nowrap">
                  <strong>Comments</strong>
                </StyledTable.Td>
                <StyledTable.Td>{tariff.tariff_combination.export_tariff_comments}</StyledTable.Td>
              </tr>*/}
            </tbody>
          </StyledTable>
        </StyledKeylineDiv>
      </div>
      {!hasTariffBeenRecentlyUpdated && <div className="mb-4" />}

      {/* TODO: How do we calculate this? <p>
          <strong>Variable Import with Fixed Flat Export</strong>
        </p> */}

      {!hasTariffBeenRecentlyUpdated && (
        <>
          <StyledKeylineDiv>
            <p>
              <strong>With this tariff and {theme.language.appName}, your annual bill would have been:</strong>
            </p>
            <p className="mb-0">
              <FormattedTariffValues exportValue={exportValue} importValue={importValue} />
            </p>
          </StyledKeylineDiv>
          <Button
            onClick={() => {
              window.scrollTo(0, 0);
              return history.push(
                `/app/tariffs/recommended/${tariff.tariff_combination.tariff_standard_combination_id}`
              );
            }}
            variant="secondary"
            className="mt-3"
            block
          >
            View tariff details
          </Button>
        </>
      )}
    </>
  );
};

export default TariffItem;
